import { CATALOG_PAGE_COMPONENT_TYPES } from '@/catalog-apps/components/AppPage2/catalogComponentTypes'
import { useAppPageLayout } from '@/catalog-apps/components/AppPage2/useAppPageLayout'
import { TComponentType } from '@/catalog-apps/components/AppPage2/types'
import { SingleSelectCombobox } from '@/components/form-components/SingleSelectCombobox'
import { useCallback } from 'react'

function toLabel(value: string): string {
  return value.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
}

const OPTIONS = CATALOG_PAGE_COMPONENT_TYPES.map((value) => ({
  value,
  label: toLabel(value),
}))

export function BuilderComponentSelector({ containerId, type }: { containerId: string; type: TComponentType }) {
  // const [selected, setSelected] = useState<TComponentType | null>(() => (type === 'component-type' ? null : type))
  const { setComponentType } = useAppPageLayout()
  const handleChange = useCallback(
    (value: TComponentType | null) => {
      // setSelected(value)
      setComponentType(containerId, value ? value : 'component-type')
    },
    [containerId, setComponentType]
  )

  return (
    <SingleSelectCombobox
      className="h-6 min-w-52 rounded-t-none bg-primary/10"
      placeholder="Preview component..."
      triggerVariant="secondary"
      options={OPTIONS}
      // selectedValue={selected}
      selectedValue={type === 'component-type' ? null : type}
      onSelectionChange={handleChange}
      portalPopover={true}
    />
  )
}
